import {NgModule} from '@angular/core';
import {MeasurementsFeatureComponent} from './measurements-feature/measurements-feature.component';
import {MeasurementsService} from './measurements.service';
import {SharedProviderModule} from '../shared/shared.module';
import {MeasurementsLiveComponent} from './measurements-live/measurements-live.component';
import {NgxChartsModule} from '@mipro/ngx-charts';
import {OverlayPanelModule} from '../components/overlay-panel/overlay-panel.module';
import {LinkingCrudService} from '../linking/linking.service';
import {ElementUtilsModule} from '../element-utils/element-utils.module';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    ElementUtilsModule,
    OverlayPanelModule,
    NgxChartsModule,
    NgbDatepickerModule,
    SharedProviderModule
  ],
  declarations: [MeasurementsFeatureComponent, MeasurementsLiveComponent],
  exports: [MeasurementsFeatureComponent, MeasurementsLiveComponent],
  providers: [MeasurementsService, LinkingCrudService]
})
export class MeasurementsModule {
}
